var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21660_191674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4884 2.1563C10.1759 1.84372 9.75207 1.66806 9.31008 1.66797H3.33341C2.89139 1.66797 2.46746 1.84356 2.1549 2.15612C1.84234 2.46868 1.66675 2.89261 1.66675 3.33464V9.3113C1.66684 9.75329 1.8425 10.1771 2.15508 10.4896L9.40841 17.743C9.78718 18.1193 10.2995 18.3306 10.8334 18.3306C11.3674 18.3306 11.8797 18.1193 12.2584 17.743L17.7417 12.2596C18.1181 11.8809 18.3294 11.3686 18.3294 10.8346C18.3294 10.3007 18.1181 9.7884 17.7417 9.40964L10.4884 2.1563Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 6.66536C6.48004 6.66536 6.66659 6.47882 6.66659 6.2487C6.66659 6.01858 6.48004 5.83203 6.24992 5.83203C6.0198 5.83203 5.83325 6.01858 5.83325 6.2487C5.83325 6.47882 6.0198 6.66536 6.24992 6.66536Z",
    fill: "#155DFC",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21660_191674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9cce0b21f45270f92440969f8b260959.svg";
export { ForwardRef as ReactComponent };